class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('[data-tab-target]');
        this.contents = this.querySelectorAll('[data-tab-content]');

        this.init();
    }

    init(){
        this.tabs.forEach(tab => {
            tab.addEventListener('click', (event) => {
                event.preventDefault();

                const target = tab.getAttribute("data-tab-target");
                this.contents.forEach(tabContent => {
                    tabContent.classList.remove('active');
                })
                this.tabs.forEach(tab => {
                    tab.classList.remove('active');
                });
                tab.classList.add('active');
                this.querySelector(target).classList.add('active');
            })
        });
    }
}
customElements.define('product-tabs', ProductTabs)